import {
  ChangeDetectionStrategy,
  Component, computed,
  inject,
  input,
  model,
  output,
} from '@angular/core';
import { MatIconButton } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatToolbarModule } from '@angular/material/toolbar';
import { SafeUrl } from '@angular/platform-browser';
import { RouterLink } from '@angular/router';
import { MenuService } from '@core/services/menu/menu.service';
import {AuthService} from '@core/services/auth/auth.service';
import {toSignal} from '@angular/core/rxjs-interop';
import {MsalService} from '@azure/msal-angular';

@Component({
  selector: 'sqep-header',
  imports: [
    RouterLink,
    MatIconModule,
    MatIconButton,
    MatToolbarModule
  ],
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HeaderComponent {

  private readonly authService = inject(AuthService);
  private readonly msalService = inject(MsalService);

  protected navbarBgClass = input<string>();
  protected clientLogoAsset = input<string>();
  protected helpUrl = model<SafeUrl | undefined>();
  protected userUPN = input.required<string>();
  protected hideMenuToggle = input<boolean>(false);
  protected toggle = output();
  private readonly homeMenu = inject(MenuService);

  public isLoggedIn = toSignal(this.authService.authenticationStatusSubj);
  public loggedInName = computed(() => this.msalService.instance.getActiveAccount().name ?? "");

  setHomeMenu() {
    this.homeMenu.selectHomeMenu(true);
  }

  logout() {
    this.authService.logout();
  }
}
